module.exports = __webpack_public_path__ + "img/bbzk.f484e664.png";